import api from "./client";

export const listInverters = async () => {
  const { data } = await api.get("/inverters/");
  return data;
};

export const listInvertersBySite = async (siteId) => {
  const { data } = await api.get(`/inverters/site/${siteId}`);
  return data;
};

export const createInverter = async (payload) => {
  const { data } = await api.post("/inverters/", payload);
  return data;
};

export const deleteInverter = async (id) => {
  const { data } = await api.delete(`/inverters/${id}/`);
  return data;
};

export const updateInverter = async (id, payload) => {
  const { data } = await api.put(`/inverters/${id}`, payload);
  return data;
};

export const canDeleteInverter = async (id) => {
  const { data } = await api.get(`/inverters/${id}/can_delete`);
  return data;
};
